import { gql } from '@apollo/client';

export const GET_MY_ELEMENTS_SIDEBAR_COMBINED_DATA = gql`
  query GetMyElementsSidebarCombinedData($volunteerId: String!, $startDate: Date, $endDate: Date) {
    orgName
    vm {
      volunteer(volunteerId: $volunteerId) {
        volunteerId
        # Profile data
        profile {
          preferredName
          lastName
          avatarUrl
          # Tasks data
          completedTasks {
            completedTaskId
            task {
              taskId
            }
          }
        }
        # Activity enrolments for role detection
        activityEnrolments {
          position
        }
        # Upcoming rosters for availability alert
        upcomingRosters(startDate: $startDate, endDate: $endDate) {
          ... on VOLUNTEER_UpcomingRosterCancellationType {
            upcomingRosterId
            __typename
          }
          ... on VOLUNTEER_UpcomingRosterAvailabilityType {
            upcomingRosterId
            __typename
          }
          ... on VOLUNTEER_UpcomingRosterRosteringType {
            upcomingRosterId
            __typename
          }
          ... on VOLUNTEER_UpcomingRosterUnavailabilityType {
            upcomingRosterId
            __typename
          }
          ... on VOLUNTEER_UpcomingRosterUnspecifiedType {
            upcomingRosterId
            __typename
          }
        }
      }
      # Tasks list
      tasks {
        taskId
        cake {
          cakeType
        }
        dateRemoved
      }
      # Unread news count
      bulletins {
        bulletinId
        hasVolunteerViewedBulletin(volunteerId: $volunteerId)
      }
      # Recent news
      mostRecentBulletin {
        bulletinId
        title
        content
        dateCreated
        createdBy {
          profile {
            preferredName
            lastName
          }
        }
        dateUpdated
        lastUpdatedBy {
          profile {
            preferredName
            lastName
          }
        }
      }
    }
  }
`;
